/** @module csi/gallery/Suspend */
define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare, Controller) {

	return declare(Controller, {
		/**
		 * @override
		 * Unsuspend view
		 */
		postProcessSuccess() {
			this.widget.suspendView(!!this.actionValue);
		}
	});
});